export default class HeaderProfile {
    constructor() {
        this.container = document.querySelector('.header-profile');
        if (!this.container) return;

        this.trigger = this.container.querySelector('.header-profile__trigger');
        this.dropdown = this.container.querySelector('.header-profile__dropdown');
        this.langSwitcher = document.querySelector('.lang-switcher');
        this.langTrigger = this.langSwitcher?.querySelector('.lang-switcher__current');

        this.init();
    }

    init() {
        this.trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggle();
        });

        // Close on click outside
        document.addEventListener('click', (e) => {
            if (!this.container.contains(e.target)) {
                this.close();
            }
        });

        // Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.close();
            }
        });

        if (this.langSwitcher) {
            this.langSwitcher.addEventListener('mouseenter', () => this.close());
            this.langSwitcher.addEventListener('focusin', () => this.close());
            this.langTrigger?.addEventListener('click', () => {
                const isOpen = this.langSwitcher.classList.toggle('is-open');
                this.langTrigger.setAttribute('aria-expanded', String(isOpen));
                this.close();
            });
            document.addEventListener('click', (event) => {
                if (!this.langSwitcher.contains(event.target)) this.closeLanguage();
            });
            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') this.closeLanguage();
            });
        }

        // Handle mobile profile button if it exists for extra logic if needed
        // (Mobile is usually just a direct link, but could be unified later)
    }

    toggle() {
        const isActive = this.dropdown.classList.contains('is-active');
        if (isActive) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.closeLanguage();
        document.body.classList.add('is-profile-menu-open');
        this.dropdown.classList.add('is-active');
        this.trigger.classList.add('is-active');
        this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
        document.body.classList.remove('is-profile-menu-open');
        this.dropdown.classList.remove('is-active');
        this.trigger.classList.remove('is-active');
        this.trigger.setAttribute('aria-expanded', 'false');
    }

    closeLanguage() {
        this.langSwitcher?.classList.remove('is-open');
        this.langTrigger?.setAttribute('aria-expanded', 'false');
    }
}
